export enum DataKey {
  // Enphase Customer Flow
  EnphaseCustomer = 'isEnphaseCustomer',
  CustomerHome = 'customerHome',
  UpgradeSystem = 'upgradeSystem',
  UpgradeMicroinverters = 'upgradeMicroinverters',
  AddEVCharger = 'addEVCharger',
  TechnicalSupport = 'technicalSupport',
  EnergyConsumption = 'energyConsumption',

  // Current Funnel
  Property = 'property',
  Sunlight = 'sunlight',
  ElectricityBill = 'bill',
  UtilityProvider = 'utilityProvider',
  Email = 'email',
  Contact = 'contact',
}

export enum Page {
  // Enphase Customer Flow
  EnphaseCustomer = 'customer',
  EnlightenLogin = 'enlighten-login',
  CustomerHome = 'customer-home',
  UpgradeSystem = 'upgrade-system',
  UpgradeMicroinverters = 'upgrade-microinverters',
  AddEVCharger = 'add-ev-charger',
  TechnicalSupport = 'technical-support',
  BatteryInstallationSite = 'battery-installation-site',
  EnergyConsumption = 'energy-consumption',

  // Current Funnel
  Property = 'property',
  UnableToService = 'unable-to-service',
  Sunlight = 'sunlight',
  Address = 'address',
  ElectricityBill = 'electricity-bill',
  UtilityProvider = 'utility-provider',
  Email = 'email',
  Contact = 'contact',

  // Top-level pages
  Calculating = 'calculating',
  Processing = 'processing',
  Success = 'success',
}

export enum CustomerHomeAction {
  UpgradeSystem = 'Upgrade your solar system',
  AddEVCharger = 'Add EV charger',
  Support = 'Support',
}

export enum UpgradeSystem {
  Solar = 'Add more solar',
  Battery = 'Add battery',
  SolarAndBattery = 'Add more solar and battery',
  UpgradeMicroinverter = 'Upgrade microinverters',
}

export enum Property {
  SingleFamilyHome = 'Single family home',
  CondoApartment = 'Condo / Apartment',
  MobileHome = 'Mobile home',
  Commercial = 'Commercial',
}

export enum PropertyValue {
  SingleFamilyHome = 'Single Family Home',
  CondoApartment = 'Condo / Apartment',
  MobileHome = 'Mobile Home',
  Commercial = 'Commercial',
}

export enum Sunlight {
  ALot = 'A lot',
  Some = 'Some',
  NotMuch = 'Not much',
  Uncertain = 'Uncertain',
}

export enum Shade {
  NoShade = 'No Shade',
  SomeShade = 'A Little Shade',
  LotOfShade = 'A Lot Of Shade',
  Uncertain = 'Uncertain',
}

export enum AddressOwnership {
  Own = 'Own',
  Rent = 'Rent',
}
